module.exports = __webpack_public_path__ + "static/media/image_59.d25bc268.png";